const pad = (value) => String(value).padStart(2, '0');

export const toDateKey = (date) => (
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
);

export const parseDateKey = (dateKey) => {
  const [year, month, day] = String(dateKey).split('-').map(Number);
  return new Date(year, (month || 1) - 1, day || 1);
};

export const getTodayKey = () => toDateKey(new Date());

export const addDays = (dateKey, amount) => {
  const date = parseDateKey(dateKey);
  date.setDate(date.getDate() + amount);
  return toDateKey(date);
};

export const getWeekDays = (dateKey) => {
  const current = parseDateKey(dateKey);
  const mondayOffset = current.getDay() === 0 ? -6 : 1 - current.getDay();
  current.setDate(current.getDate() + mondayOffset);

  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(current);
    date.setDate(current.getDate() + index);
    return {
      key: toDateKey(date),
      day: date.getDate(),
      weekday: ['일', '월', '화', '수', '목', '금', '토'][date.getDay()],
    };
  });
};

export const formatKoreanDate = (dateKey) => {
  const date = parseDateKey(dateKey);
  const weekday = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
  return `${date.getFullYear()}. ${date.getMonth() + 1}. ${date.getDate()} (${weekday})`;
};

export const getDaysUntil = (dateKey, todayKey = getTodayKey()) => {
  const toUtcTime = (key) => {
    const [year, month, day] = String(key).split('-').map(Number);
    return Date.UTC(year, (month || 1) - 1, day || 1);
  };
  return Math.round((toUtcTime(dateKey) - toUtcTime(todayKey)) / 86400000);
};

export const formatDDay = (dateKey, todayKey = getTodayKey()) => {
  const days = getDaysUntil(dateKey, todayKey);
  return days === 0 ? 'D-DAY' : `D-${days}`;
};

export const getMinutesBetween = (startTime, endTime) => {
  const [startHour, startMinute] = String(startTime || '').split(':').map(Number);
  const [endHour, endMinute] = String(endTime || '').split(':').map(Number);
  if (![startHour, startMinute, endHour, endMinute].every(Number.isFinite)) return 0;
  return Math.max(0, (endHour * 60 + endMinute) - (startHour * 60 + startMinute));
};

export const formatMinutes = (minutes) => {
  const safeMinutes = Math.max(0, Number(minutes) || 0);
  const hours = Math.floor(safeMinutes / 60);
  const remainMinutes = safeMinutes % 60;
  if (!hours) return `${remainMinutes}분`;
  if (!remainMinutes) return `${hours}시간`;
  return `${hours}시간 ${remainMinutes}분`;
};
